import {
  collection,
  doc,
  addDoc,
  updateDoc,
  getDoc,
  getDocs,
  query,
  where,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from './firebase-init';

const DOCS_COLLECTION = 'documents';

// ── Document types ────────────────────────────────────────────────────────────
export const DOC_TYPES = [
  { key: 'estimate',    label: 'Estimate',          icon: '💰' },
  { key: 'cutlist',     label: 'Cut List',           icon: '📋' },
  { key: 'glass',       label: 'Glass Order',        icon: '🔲' },
  { key: 'flexscreen',  label: 'FlexScreen Order',   icon: '🪟' },
  { key: 'shoporder',   label: 'Shop Order',         icon: '🏭' },
  { key: 'installer',   label: 'Installer Work Order', icon: '🚚' },
];

// ── Save a generated document record ─────────────────────────────────────────
export async function saveDocument(jobId, docType, metadata = {}) {
  const ref = await addDoc(collection(db, DOCS_COLLECTION), {
    jobId,
    docType,
    status: 'generated',
    generatedAt: serverTimestamp(),
    ...metadata,
  });
  return ref.id;
}

// ── Get all documents for a job ───────────────────────────────────────────────
export async function getDocumentsForJob(jobId) {
  const q = query(
    collection(db, DOCS_COLLECTION),
    where('jobId', '==', jobId)
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

// ── Get a single document record ──────────────────────────────────────────────
export async function getDocument(docId) {
  const snap = await getDoc(doc(db, DOCS_COLLECTION, docId));
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
}

// ── Update a document record ──────────────────────────────────────────────────
export async function updateDocument(docId, updates) {
  await updateDoc(doc(db, DOCS_COLLECTION, docId), {
    ...updates,
    updatedAt: serverTimestamp(),
  });
}

// ── Build a full document status map for a job ────────────────────────────────
// Returns { estimate: { status, generatedAt, ... }, cutlist: { ... }, ... }
export async function getDocumentStatusMap(jobId) {
  const docs = await getDocumentsForJob(jobId);

  // Start with all doc types as pending
  const map = {};
  DOC_TYPES.forEach(t => {
    map[t.key] = { status: 'pending', generatedAt: null };
  });

  // Fill in what has been generated
  docs.forEach(d => {
    if (map[d.docType] !== undefined) {
      map[d.docType] = {
        status: 'generated',
        generatedAt: d.generatedAt,
        docId: d.id,
        ...d,
      };
    }
  });

  return map;
}